import { z } from 'zod';

export const addEmployeeSchema = z.object({
  firstName: z.string().trim().min(1, 'settingsViews.employees.addEmployeeDialog.firstNameRequired'),
  lastName: z.string().trim().min(1, 'settingsViews.employees.addEmployeeDialog.lastNameRequired'),
  email: z
    .string()
    .trim()
    .min(1, 'settingsViews.employees.addEmployeeDialog.emailInvalid')
    .email('settingsViews.employees.addEmployeeDialog.emailInvalid'),
});

export type AddEmployeeForm = z.infer<typeof addEmployeeSchema>;
